import React from "react";
import classes from "./AvailableScreeningsCard.module.scss";

const AvailableScreeningsCard = ({ label, total }) => (
  <div className={classes.AvailableScreeningsCard}>
    <span className={classes.Label}>{label}</span>
    <span className={classes.Total}>{total}</span>
  </div>
);

export default AvailableScreeningsCard;
